import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IConfigReenvio } from 'modelos/src';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import {
  ConfigReenviosService,
  ISoflexDiagActivo,
  ISoflexDiagnostico,
} from '../../../../../auxiliares/servicios/http/config-reenvios.service';

export interface ITestSoflexData {
  /// Config ya guardada
  idConfigReenvio?: string;
  /// Config del formulario (puede no estar guardada todavía)
  config?: IConfigReenvio;
}

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-test-soflex',
  templateUrl: './test-soflex.component.html',
  styleUrl: './test-soflex.component.scss',
})
export class TestSoflexComponent implements OnInit {
  public data = inject<ITestSoflexData>(MAT_DIALOG_DATA);
  public dialogRef = inject<MatDialogRef<TestSoflexComponent>>(MatDialogRef);
  public helper = inject(HelperService);
  private service = inject(ConfigReenviosService);

  public loading = false;
  public error?: string;
  public diag?: ISoflexDiagnostico;
  public soloConProblemas = false;
  public busqueda = '';

  get activosVisibles(): ISoflexDiagActivo[] {
    let activos = this.diag?.activos || [];
    if (this.soloConProblemas) {
      activos = activos.filter((a) => a.advertencias.length > 0);
    }
    const texto = this.busqueda.trim().toLowerCase();
    if (!texto) return activos;
    return activos.filter((a) => this.coincide(a, texto));
  }

  /// Busca en patente, identificación, tracker, flota, cliente, fleetId y los
  /// campos del device que se enviarían a Soflex.
  private coincide(activo: ISoflexDiagActivo, texto: string): boolean {
    const campos = [
      activo.patente,
      activo.identificacion,
      activo.nombreTracker,
      activo.idTracker,
      activo.nombreGrupo,
      activo.nombreCliente,
      activo.fleetId,
      activo.parentFleetId,
      activo.fleetName,
      activo.idActivo,
      activo.device?.deviceid,
      activo.device?.plate,
      activo.device?.brand,
      activo.device?.model,
      activo.device?.year,
      activo.device?.description,
      ...activo.advertencias,
    ];
    return campos.some(
      (c) => !!c && c.toString().toLowerCase().includes(texto),
    );
  }

  public async probar(): Promise<void> {
    this.loading = true;
    this.error = undefined;
    try {
      this.diag = await this.service.diagnosticoSoflex({
        idConfigReenvio: this.data.idConfigReenvio,
        config: this.data.config,
      });
    } catch (error: any) {
      console.error(error);
      this.diag = undefined;
      this.error =
        error?.error?.message ||
        error?.message ||
        'No se pudo ejecutar el test de la configuración';
    }
    this.loading = false;
  }

  public cerrar(): void {
    this.dialogRef.close();
  }

  async ngOnInit() {
    await this.probar();
  }
}
